<template>
  <form @submit.stop.prevent>
    <FlexLayout role="region">
      <BlockContainer>
        <!-- Use dynamic fieldsConfig instead of hardcoded REGISTRATION section -->
        <Input
          v-if="fieldsConfig.firstName && fieldsConfig.firstName.visible"
          id="firstName"
          :label="$t('field.firstName')"
          type="text"
          v-model="$v.form.firstName.$model"
          :error="$v.form.firstName.$dirty && $v.form.firstName.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.firstName.required"
          :maxlength="fieldsConfig.firstName.maxLength"
          aria-describedby="register-form-firstName"
          autofocus
        />
        <Input
          v-if="fieldsConfig.lastName && fieldsConfig.lastName.visible"
          id="lastName"
          :label="$t('field.lastName')"
          type="text"
          v-model="$v.form.lastName.$model"
          :error="$v.form.lastName.$dirty && $v.form.lastName.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.lastName.required"
          :maxlength="fieldsConfig.lastName.maxLength"
          aria-describedby="register-form-lastName"
          autofocus
        />
        <Input
          v-if="fieldsConfig.emailAddr && fieldsConfig.emailAddr.visible"
          id="emailAddr"
          :label="$t('field.email')"
          type="email"
          v-model="$v.form.emailAddr.$model"
          :error="$v.form.emailAddr.$dirty && $v.form.emailAddr.$error ? $t('validation.invalidEmail') : ''"
          :required="fieldsConfig.emailAddr.required"
          :maxlength="fieldsConfig.emailAddr.maxLength"
          aria-describedby="register-form-emailAddr"
          autofocus
        />
        <Input
          v-if="fieldsConfig.telephoneNumber && fieldsConfig.telephoneNumber.visible"
          id="telephoneNumber"
          :label="$t('field.telephoneNumber')"
          type="text"
          v-model="$v.form.telephoneNumber.$model"
          :error="$v.form.telephoneNumber.$dirty && $v.form.telephoneNumber.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.telephoneNumber.required"
          :maxlength="fieldsConfig.telephoneNumber.maxLength"
          aria-describedby="register-form-telephoneNumber"
          autofocus
        />
        <Input
          v-if="fieldsConfig.cardNumber && fieldsConfig.cardNumber.visible"
          id="cardNumber"
          :label="$t('field.cardNumber')"
          type="text"
          v-model="$v.form.cardNumber.$model"
          :error="$v.form.cardNumber.$dirty && $v.form.cardNumber.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.cardNumber.required"
          :maxlength="fieldsConfig.cardNumber.maxLength"
          aria-describedby="register-form-cardNumber"
          autofocus
        />
        <Input
          v-if="fieldsConfig.customerCode && fieldsConfig.customerCode.visible"
          id="customerCode"
          :label="$t('field.customerCode')"
          type="text"
          v-model="$v.form.customerCode.$model"
          :error="$v.form.customerCode.$dirty && $v.form.customerCode.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.customerCode.required"
          :maxlength="fieldsConfig.customerCode.maxLength"
          aria-describedby="register-form-customerCode"
          autofocus
        />
        <Input
          v-if="fieldsConfig.password && fieldsConfig.password.visible"
          id="password"
          :label="$t('field.password')"
          type="password"
          v-model="$v.form.password.$model"
          :error="$v.form.password.$dirty && $v.form.password.$error ? $t('validation.passwordPolicy') : ''"
          :required="fieldsConfig.password.required"
          :maxlength="fieldsConfig.password.maxLength"
          aria-describedby="login-form-password"
          autofocus
        />
        <Input
          v-if="fieldsConfig.passwordRepeat && fieldsConfig.passwordRepeat.visible"
          id="passwordRepeat"
          :label="$t('field.passwordRepeat')"
          type="password"
          v-model="$v.form.passwordRepeat.$model"
          :error="$v.form.passwordRepeat.$dirty && $v.form.passwordRepeat.$error ? $t('validation.fieldWarningPasswordEqual') : ''"
          :required="fieldsConfig.passwordRepeat.required"
          :minLength="fieldsConfig.passwordRepeat.minLength"
          :maxlength="fieldsConfig.passwordRepeat.maxLength"
          aria-describedby="login-form-passwordRepeat"
          autofocus
        />
        <Input
          v-if="fieldsConfig.streetAddress && fieldsConfig.streetAddress.visible"
          id="streetAddress"
          :label="$t('field.street')"
          type="text"
          v-model="$v.form.streetAddress.$model"
          :error="$v.form.streetAddress.$dirty && $v.form.streetAddress.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.streetAddress.required"
          :maxlength="fieldsConfig.streetAddress.maxLength"
          aria-describedby="register-form-streetAddress"
          autofocus
        />
        <Input
          v-if="fieldsConfig.postcode && fieldsConfig.postcode.visible"
          id="postcode"
          :label="$t('field.postalCode')"
          type="text"
          v-model="$v.form.postcode.$model"
          :error="$v.form.postcode.$dirty && $v.form.postcode.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.postcode.required"
          :maxlength="fieldsConfig.postcode.maxLength"
          aria-describedby="register-form-postcode"
          autofocus
        />
        <Input
          v-if="fieldsConfig.city && fieldsConfig.city.visible"
          id="city"
          :label="$t('field.city')"
          type="text"
          v-model="$v.form.city.$model"
          :error="$v.form.city.$dirty && $v.form.city.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="fieldsConfig.city.required"
          :maxlength="fieldsConfig.city.maxLength"
          aria-describedby="register-form-city"
          autofocus
        />
        <Dropdown v-if="countriesLoaded && fieldsConfig.countryId && fieldsConfig.countryId.visible"
                     v-model="selectedCountryId"
                     :label="$t('field.country')"
                     :options="countryOptions"
                     :placeholder="$t('system.placeholder.chooseOption')"
                     :required="fieldsConfig.countryId.required"
        />
        <template #paragraph>
          <i18n path="register.label.acceptTermsAndPrivacy" tag="p" style="white-space-collapse: break-spaces;">
            <template v-slot:terms>
              <a :href="config.COMPANY.links.terms" target="_blank">{{ $t('system.label.terms') }}</a>
            </template>
            <template v-slot:privacy>
              <a :href="config.COMPANY.links.privacy" target="_blank">{{ $t('system.label.privacy') }}</a>
            </template>
          </i18n>
        </template>

        <template #actions>
          <Button type="submit" @click.stop="onClickCaptcha" :disabled="$v.$invalid" variant="primary">
            {{ mode === 'guest' ? $t('register.button.registerGuest') : $t('register.button.register') }}
          </Button>
        </template>
      </BlockContainer>
    </FlexLayout>
  </form>
</template>

<script>
import {en, de, fr} from 'vuejs-datepicker/dist/locale'
import {accountService} from "@/services/api/accountService";
import {useRegisterStore} from "@/stores/register";
import Input from "@/components/forms/Input.vue";
import Button from "@/components/actions/Button.vue";
import Dropdown from "@/components/forms/Dropdown.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import {useAuthStore} from "@/stores/auth";
import {useAppStore} from "@/stores/app";
import { isRequired, isValidEmail, isValidPassword, isSameAs } from '@/utils/validationUtils';
import {Login} from "@/constants/constants";
import {getAuthenticatedHomeRouteName, getSafeAuthenticatedRedirect} from "@/utils/authRouteUtils";

export default {
  props: {
    // Mode determines which config section and behavior to use
    /** @type {'standard' | 'parent' | 'child' | 'guest'} */
    mode: {
      type: String,
      default: 'standard', // 'standard' | 'parent' | 'child' | 'guest'
      validator: v => ['standard','parent','child', 'guest'].includes(v)
    }
  },
  data() {
    return {
      form: {
        firstName: undefined,
        lastName: undefined,
        streetAddress: undefined,
        postcode: undefined,
        city: undefined,
        countryId: undefined,
        telephoneNumber: undefined,
        emailAddr: undefined,
        cardNumber: undefined,
        customerCode: undefined,
        password: undefined,
        passwordRepeat: undefined,
      },
      en: en,
      de: de,
      fr: fr,
      countriesLoaded: false,
      /** @type {Array<>} */
      countries: [],
      selectedCountry: undefined,
      selectedCountryId: 0,
      responseToken: "",
      hidePassword: true,
      hidePasswordRepeat: true,
      submit: false,
    }
  },
  setup() {
    const registerStore = useRegisterStore();
    const authStore = useAuthStore();
    const appStore = useAppStore();
    return { registerStore, authStore, appStore };
  },
  computed: {
    config() {
      return window.config;
    },
    // Map mode to config section key
    modeKey() {
      switch (this.mode) {
        case 'parent': return 'REGISTRATION_PARENT';
        case 'child': return 'REGISTRATION_CHILD';
        case 'guest': return 'GUEST_CHECKOUT';
        default: return 'REGISTRATION';
      }
    },
    fieldsConfig() {
      const section = this.config[this.modeKey];
      if (section && section.FIELDS) return section.FIELDS;
      // Fallback to REGISTRATION
      return (this.config.REGISTRATION || {}).FIELDS || {};
    },
    countryOptions() {
      if (!Array.isArray(this.countries)) return [];
      return this.countries.map(c => ({ value: c.id, label: c.name }));
    },
    registrationTypeParam() {
      if (this.mode === 'child') return '1';
      if (this.mode === 'parent') return '0';
      if (this.mode === 'guest') return '2';
      return 0;
    }
  },
    components:{
      BlockContainer,
      FlexLayout,
      Dropdown: Dropdown,
      Button,
      Input,
    },
    // Dynamic validations depend on current mode / fieldsConfig
    validations() {
      const fields = this.fieldsConfig;
      const passwordField = fields.password || {};
      const passwordRepeatField = fields.passwordRepeat || {};
      return {
        form: {
          firstName: { required: v => isRequired(v, fields.firstName) },
          lastName: { required: v => isRequired(v, fields.lastName) },
          streetAddress: { required: v => isRequired(v, fields.streetAddress) },
          postcode: { required: v => isRequired(v, fields.postcode) },
          city: { required: v => isRequired(v, fields.city) },
          countryId: { required: v => isRequired(v, fields.countryId) },
          telephoneNumber: { required: v => isRequired(v, fields.telephoneNumber) },
          emailAddr: {
            required: v => isRequired(v, fields.emailAddr),
            email: isValidEmail
          },
          cardNumber: { required: v => isRequired(v, fields.cardNumber) },
          customerCode: { required: v => isRequired(v, fields.customerCode) },
          password: {
            required: v => isRequired(v, passwordField),
            valid: v => isValidPassword(v, passwordField)
          },
          passwordRepeat: {
            required: v => isRequired(v, passwordRepeatField),
            sameAsPassword: v => isSameAs(v, this.form.password)
          }
        }
      }
    },
  methods: {
    onClickCaptcha(e) {
      this.submit = true;
      console.debug("onClickCaptcha");
      e.preventDefault();
      // eslint-disable-next-line no-undef
      if(window.config.G_CAPTCHA.enabled === true && typeof grecaptcha !== 'undefined')
      {
        const self = this;
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function() {
          // eslint-disable-next-line no-undef
          grecaptcha.execute(window.config.G_CAPTCHA.siteKey, {action: 'submit'}).then(function(token) {
            self.responseToken = token;
            self.onSubmit(e);
          });
        });
      }
      else
      {
        this.onSubmit(e);
      }
    },
    showPassword() {
      this.hidePassword = !this.hidePassword;
    },
    showPasswordRepeat() {
      this.hidePasswordRepeat = !this.hidePasswordRepeat;
    },
    selectCountry(countryId) {
      this.form.countryId = countryId;
    },
    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.makeToast('danger', this.$t('notification.fillAllRequiredFields'));
        return;
      }

      const allowNoRegister = this.mode === 'guest';
      const result = await accountService.register(
        this.responseToken,
        this.registrationTypeParam,
        this.form.gender,
        this.form.firstName,
        this.form.lastName,
        this.form.emailAddr,
        this.form.cardNumber,
        this.form.customerCode,
        this.form.streetAddress,
        this.form.postcode,
        this.form.city,
        this.form.countryId,
        this.form.telephoneNumber,
        this.form.password,
        allowNoRegister
      );

      if (result.errorCode > 0) {
        if (result.errorCode === 10) // password does not meet policy
        {
          this.makeToast('danger', this.$t('register.messages.error.passwordPolicy'));
        } else {
          this.makeToast('danger', result.errorMsg);
        }
        return;
      }
      else if (result.exception !== undefined) {
        this.makeToast('danger', result.exception.msg);
        return;
      }

      if (this.mode === 'guest') {
        // Authenticate as guest and redirect
        this.authStore.setAuthenticated(true, Login.Mode.GUEST, Login.UserType.GUEST_USER);
        this.authStore.setLoginChecked(true);

        const redirectRouteName = this.appStore?.redirectRouteName;
        if (redirectRouteName) {
          const redirectTarget = getSafeAuthenticatedRedirect(
            this.authStore,
            this.config,
            redirectRouteName,
            this.appStore.redirectRouteParams,
            this.appStore.redirectRouteQuery,
          );
          this.appStore.clearRedirectRoute();
          this.$navigate(redirectTarget.name, {
            params: redirectTarget.params,
            query: redirectTarget.query,
            withReplace: true,
          });
        } else {
          this.$navigate(getAuthenticatedHomeRouteName(this.config, this.authStore), { withReplace: true });
        }
      } else {
        // Post-success navigation differs by mode
        if (this.mode === 'child') {
          this.$navigateToStudentAccounts && this.$navigateToStudentAccounts(true);
        } else {
          this.appStore.setFlashToast({
            variant: 'success',
            message: this.$t('register.messages.info.onRegister'),
          });

          if (this.mode === 'standard' && this.registerStore) {
            this.registerStore.clearCardNumber();
          }
          this.$navigateToLogin(true);
        }
      }
    },
  },
  async created(){
    // Pre-fill card number only for standard mode (legacy behavior)
    if (this.mode === 'standard' && this.registerStore) {
      this.form.cardNumber = this.registerStore.getCardNumber;
    }

    const result = await accountService.getCountries();

    this.countries = result.countries;
    if (result.selectedCountry !== undefined) {
      this.selectedCountry = result.selectedCountry;
      this.form.countryId = result.selectedCountry.id;
      this.selectedCountryId = result.selectedCountry.id;
    } else {
      if (this.countries.length > 0)
        this.selectCountry(this.countries[0].id);
    }

    this.countriesLoaded = true;
  },
}
</script>

<style scoped>
    input[type="password"]::-ms-reveal {
      display: none;
    }
</style>
